import { t } from 'i18next';

import { ContextElementModelOutput } from '../../../../../../../gamma-api';

export const DEFAULT_ELMA365_FILTRATION_JSON = `{
  "tf": {"__name": "<search text>"}
}`;

export enum Elma365FormPropertyDataTypes {
  STRING = 'string',
  TEXT = 'text',
  ROLE = 'role',
  MARKDOWN = 'markdown',
  INTEGER = 'integer',
  FLOAT = 'float',
  CHECKBOX = 'checkbox',
  RADIO = 'radio',
  BOOLEAN = 'boolean',
  LINK = 'link',
  TABLE = 'table',
  FULL_NAME = 'full_name',
  DATETIME = 'datetime',
  DATE = 'date',
  TIME = 'time',
  ENUM = 'enum',
  EMAIL = 'email',
  PHONE = 'phone',
  ACCOUNT = 'account',
  MONEY = 'money',
  SYS_USER = 'sys_user',
  SYS_COLLECTION = 'sys_collection',
  REF_ITEM = 'ref_item',
  FILE = 'file',
  IMAGE = 'image',
  STATUS = 'status',
  CATEGORY = 'category',
  SYS_DIRECTORY = 'sys_directory',
  JSON = 'json',
  UUID = 'uuid',
  COLLECTION_TYPE = 'collection_type',
}

export const getFormPropertyType = (dataType?: string, additionalDataType?: string): string => {
  if (dataType === Elma365FormPropertyDataTypes.STRING) return t('Source settings: ELMA365: Fields: String');
  if (dataType === Elma365FormPropertyDataTypes.TEXT) return t('Source settings: ELMA365: Fields: Text');
  if (dataType === Elma365FormPropertyDataTypes.MARKDOWN) return t('Source settings: ELMA365: Fields: Markdown');

  if (dataType === Elma365FormPropertyDataTypes.INTEGER) return t('Source settings: ELMA365: Fields: Integer');
  if (dataType === Elma365FormPropertyDataTypes.FLOAT) return t('Source settings: ELMA365: Fields: Float');

  if (
    dataType === Elma365FormPropertyDataTypes.CHECKBOX ||
    dataType === Elma365FormPropertyDataTypes.RADIO ||
    dataType === Elma365FormPropertyDataTypes.BOOLEAN
  )
    return t('Source settings: ELMA365: Fields: Boolean');

  if (dataType === Elma365FormPropertyDataTypes.LINK) return t('Source settings: ELMA365: Fields: Link');

  if (dataType === Elma365FormPropertyDataTypes.REF_ITEM) return t('Source settings: ELMA365: Fields: Custom app');

  if (dataType === Elma365FormPropertyDataTypes.FULL_NAME) return t('Source settings: ELMA365: Fields: Full name');

  if (dataType === Elma365FormPropertyDataTypes.DATETIME) return t('Source settings: ELMA365: Fields: Date and time');
  if (dataType === Elma365FormPropertyDataTypes.DATE) return t('Source settings: ELMA365: Fields: Date');
  if (dataType === Elma365FormPropertyDataTypes.TIME) return t('Source settings: ELMA365: Fields: Time');

  if (dataType === Elma365FormPropertyDataTypes.ENUM) return t('Source settings: ELMA365: Fields: Category');

  if (dataType === Elma365FormPropertyDataTypes.TABLE) return t('Source settings: ELMA365: Fields: Table');

  if (dataType === Elma365FormPropertyDataTypes.EMAIL) {
    if (additionalDataType === 'main') return t('Source settings: ELMA365: Fields: Email: Main');
    if (additionalDataType === 'home') return t('Source settings: ELMA365: Fields: Email: Home');
    if (additionalDataType === 'work') return t('Source settings: ELMA365: Fields: Email: Work');
    return t('Source settings: ELMA365: Fields: Email');
  }

  if (dataType === Elma365FormPropertyDataTypes.PHONE) {
    if (additionalDataType === 'main') return t('Source settings: ELMA365: Fields: Phone: Main');
    if (additionalDataType === 'home') return t('Source settings: ELMA365: Fields: Phone: Home');
    if (additionalDataType === 'work') return t('Source settings: ELMA365: Fields: Phone: Work');
    if (additionalDataType === 'mobile') return t('Source settings: ELMA365: Fields: Phone: Mobile');
    if (additionalDataType === 'work-fax') return t('Source settings: ELMA365: Fields: Phone: Work fax');
    if (additionalDataType === 'pager') return t('Source settings: ELMA365: Fields: Phone: Pager');
    return t('Source settings: ELMA365: Fields: Phone');
  }

  if (dataType === Elma365FormPropertyDataTypes.ACCOUNT) {
    if (additionalDataType === 'telegram') return t('Source settings: ELMA365: Fields: Account: Telegram');
    if (additionalDataType === 'whatsapp') return t('Source settings: ELMA365: Fields: Account: WhatsApp');
    if (additionalDataType === 'instagram') return t('Source settings: ELMA365: Fields: Account: Instagram');
    if (additionalDataType === 'viber') return t('Source settings: ELMA365: Fields: Account: Viber');
    if (additionalDataType === 'facebook') return t('Source settings: ELMA365: Fields: Account: Facebook');
    if (additionalDataType === 'vkontakte') return t('Source settings: ELMA365: Fields: Account: VK');
    return t('Source settings: ELMA365: Fields: Account');
  }

  if (dataType === Elma365FormPropertyDataTypes.MONEY) {
    if (additionalDataType === 'RUB') return t('Source settings: ELMA365: Fields: Money: ₽');
    if (additionalDataType === 'USD') return t('Source settings: ELMA365: Fields: Money: $');
    if (additionalDataType === 'EUR') return t('Source settings: ELMA365: Fields: Money: €');
    if (additionalDataType === 'AZN') return t('Source settings: ELMA365: Fields: Money: ₼');
    if (additionalDataType === 'BYN') return t('Source settings: ELMA365: Fields: Money: Br');
    if (additionalDataType === 'GBP') return t('Source settings: ELMA365: Fields: Money: £');
    if (additionalDataType === 'JPY') return t('Source settings: ELMA365: Fields: Money: ¥');
    if (additionalDataType === 'KZT') return t('Source settings: ELMA365: Fields: Money: ₸');
    if (additionalDataType === 'CNY') return t('Source settings: ELMA365: Fields: Money: 元');
    if (additionalDataType === 'GEL') return t('Source settings: ELMA365: Fields: Money: ₾');
    if (additionalDataType === 'ILS') return t('Source settings: ELMA365: Fields: Money: ₪');
    if (additionalDataType === 'TRY') return t('Source settings: ELMA365: Fields: Money: ₺');
    if (additionalDataType === 'UAH') return t('Source settings: ELMA365: Fields: Money: ₴');
    return `${t('Source settings: ELMA365: Fields: Money')}: ${additionalDataType}`;
  }

  if (dataType === Elma365FormPropertyDataTypes.SYS_USER) return t('Source settings: ELMA365: Fields: User');
  if (dataType === Elma365FormPropertyDataTypes.ROLE) return t('Source settings: ELMA365: Fields: Role');

  if (dataType === Elma365FormPropertyDataTypes.SYS_COLLECTION)
    return t('Source settings: ELMA365: Fields: Application');

  if (dataType === Elma365FormPropertyDataTypes.FILE) return t('Source settings: ELMA365: Fields: File');
  if (dataType === Elma365FormPropertyDataTypes.IMAGE) return t('Source settings: ELMA365: Fields: Image');

  if (dataType === Elma365FormPropertyDataTypes.STATUS) return t('Source settings: ELMA365: Fields: Status');

  if (dataType === Elma365FormPropertyDataTypes.CATEGORY) return t('Source settings: ELMA365: Fields: Category');

  if (dataType === Elma365FormPropertyDataTypes.SYS_DIRECTORY) return t('Source settings: ELMA365: Fields: Directory');

  if (dataType === Elma365FormPropertyDataTypes.JSON) return t('Source settings: ELMA365: Fields: JSON');

  if (dataType === Elma365FormPropertyDataTypes.UUID) return t('Source settings: ELMA365: Fields: UUID');

  if (dataType === Elma365FormPropertyDataTypes.COLLECTION_TYPE)
    return t('Source settings: ELMA365: Fields: Collection type');

  return `${t('Source settings: ELMA365: Fields: Unknown type')} (${dataType}${
    additionalDataType ? ` - ${additionalDataType}` : ''
  })`;
};

export const isAllowedForParsingField = (field: ContextElementModelOutput): boolean => {
  if (field.deleted) return false;
  if (field.view?.hidden) return false;
  return true;
};
